import { render, staticRenderFns } from "./reviewTabList.vue?vue&type=template&id=c5399c60&"
import script from "./reviewTabList.vue?vue&type=script&lang=js&"
export * from "./reviewTabList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports